/* eslint-disable react/prop-types */
import React from 'react'
import { matchPath } from 'react-router-dom'


export const routePrefix = '/:wl(\\d+)?/:cu(\\d+)?'

export const getBaseRoute = (path, postfix = '') => {
  const baseRoute = matchPath(path, {
    path: `${routePrefix}${postfix}`,
    exact: false,
    strict: false,
  })

  baseRoute.basePath = baseRoute.url
  delete baseRoute.url
  return baseRoute
}

export const withBaseRoute = (WrappedComponent, postfix = '') => (props) => {
  const { location, history } = props

  const baseRoute = getBaseRoute(location.pathname, postfix)

  const navigateTo = (...args) => {
    if (!args || args.length === 0) {
      return
    }

    let state = null
    let parts = args

    // check for state {} object to pass to new page component
    if (typeof args[args.length - 1] === 'object') {
      state = args[args.length - 1]
      parts = parts.slice(0, parts.length - 1)
    }

    const page = `${baseRoute.basePath}/${parts.join('/')}`
    history.push(page, state)
  }

  return (
    <WrappedComponent {...props} baseRoute={baseRoute} navigateTo={navigateTo} />
  )
}
